import elLocale from 'element-ui/lib/locale/lang/es';

export default {
	// Textos internos de Element UI (message box, formularios, ...)
	el: elLocale.el,

	common: {
		loading: 'Cargando...',
		error: 'Error',
		close: 'Cerrar',
		cancel: 'Cancelar',
		send: 'Enviar',
		sending: 'Enviando...',
		signIn: 'Iniciar sesión',
		signUp: 'Crear cuenta',
		backToLogin: 'Volver al inicio de sesión',
		downloadRambox: 'Descargar Rambox',
		returnToRamboxLogin: 'Volver al inicio de sesión de Rambox',
	},

	notifications: {
		unsupportedVersion:
			'Versión no compatible: estás usando una versión desactualizada, actualízala para seguir usando Rambox.',
	},

	auth: {
		loading: {
			authenticating: 'Autenticando...',
			settingUpUser: 'Creando el usuario...',
			sendingVerificationEmail: 'Enviando el correo de verificación...',
			gettingOrganizationData: 'Obteniendo los datos de la organización...',
		},
		version: {
			notAllowedTitle: 'Versión no permitida',
			notAllowedSubtitle: 'Tu versión de Rambox ya no tiene soporte, actualízala antes de iniciar sesión.',
			checkForUpdates: 'Buscar actualizaciones',
			updateHint:
				'Puedes hacerlo desde la sección Acerca de o descargar la última versión desde nuestro sitio www.rambox.app.',
		},
		dashboard: {
			hello: '¡Hola {name}!',
			welcome: 'Bienvenido a tu panel',
			downloadDesktopApp: 'Descargar la aplicación de escritorio',
			billingPortal: 'Portal de facturación',
			helpCenter: 'Centro de ayuda',
		},
		facebook: {
			linkPrompt:
				'Para añadir {provider} como proveedor de confianza a tu cuenta de Rambox, debes iniciar sesión con alguno de los métodos que ya has usado antes:',
			passwordPlaceholder: 'Escribe tu contraseña de Rambox',
			continueWithGoogle: 'Continuar con Google',
			linked: '{provider} se vinculó a {email}',
			or: 'O',
		},
		enterprise: {
			button: 'Empresas',
			drawerTitle: 'Inicio de sesión para empresas',
			placeholder: 'id-de-tu-empresa',
		},
		signInTo: 'Inicia sesión en',
		signUpTo: 'Crea tu cuenta en',
		forIndividuals: 'Para personas',
		forBusinesses: 'Para empresas',
		providers: {
			saml: 'Iniciar sesión con {provider}',
		},
		divider: {
			signin: 'O USA TU CUENTA',
			signup: 'O USA TU CORREO',
			noAccount: '¿AÚN NO TIENES UNA CUENTA?',
		},
		form: {
			email: 'Correo electrónico',
			password: 'Contraseña',
			forgotPassword: '¿Olvidaste tu contraseña?',
		},
		signUpForRambox: 'Crea tu cuenta de Rambox',
		alreadyHaveAccount: '¿Ya tienes una cuenta? Inicia sesión',
		legal: {
			text: 'Al continuar con Google, Facebook o tu correo, aceptas los {terms} y la {privacy}.',
			terms: 'Términos de uso',
			privacy: 'Política de privacidad',
		},
		validation: {
			emailRequired: 'El correo electrónico es obligatorio.',
			emailInvalid: 'Introduce un correo electrónico válido.',
			passwordRequired: 'La contraseña es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
		},
		resetPrompt: {
			title: 'Recuperar contraseña',
			message: 'Introduce tu correo electrónico.',
			invalidEmail: 'El formato del correo electrónico no es válido.',
			sent: 'Hemos enviado un correo para restablecer la contraseña a {email}',
		},
		verifyEmail: {
			text:
				'Verifica tu cuenta haciendo clic en el enlace que enviamos a {email} antes de iniciar sesión. Si no lo recibes, sigue los pasos de',
			article: 'este artículo',
			yourEmail: 'tu correo electrónico',
		},
		errors: {
			organizationNotFound: 'No se encontró la organización',
			freshdesk: 'Hubo un error al autenticarte. Vuelve al Portal de Soporte e inténtalo de nuevo...',
			noEmailScope:
				'No pudimos obtener tu correo electrónico y lo necesitamos para identificar tu cuenta. Inicia sesión de nuevo y permite el acceso al correo.',
			noTenantId: 'La organización no está configurada correctamente.',
		},
	},

	actionHandler: {
		loading: {
			title: 'Espera un momento...',
			subtitle: 'Estamos validando tu enlace.',
		},
		verifySuccess: {
			title: '¡Correo verificado!',
			ready: 'Tu cuenta ya está lista.',
			redirecting: 'Redirigiendo en {count} segundo... | Redirigiendo en {count} segundos...',
			readyNoRedirect:
				'Tu cuenta ya está lista. Ahora puedes abrir la aplicación de escritorio de Rambox e iniciar sesión con la misma cuenta.',
		},
		reset: {
			title: 'Restablece tu contraseña',
			settingFor: 'Definiendo la nueva contraseña de {email}',
			newPassword: 'Nueva contraseña',
			repeatPassword: 'Repite la nueva contraseña',
			submit: 'Guardar la nueva contraseña',
		},
		resetSuccess: {
			title: '¡Contraseña actualizada!',
			text: 'Tu contraseña se cambió correctamente. Ya puedes iniciar sesión con la nueva contraseña.',
		},
		signinEmail: {
			title: 'Confirma tu correo electrónico',
			text: 'Introduce el correo electrónico donde recibiste esta invitación.',
			placeholder: 'Tu correo electrónico',
			continue: 'Continuar',
		},
		setPassword: {
			title: 'Define tu contraseña',
			createFor: 'Crea una contraseña para {email}',
			newPassword: 'Nueva contraseña',
			confirmPassword: 'Confirma la contraseña',
			submit: 'Guardar y continuar',
		},
		signinSuccess: {
			title: '¡Cuenta lista!',
			text: 'Tu cuenta se configuró correctamente.',
			enterpriseInfo:
				'Cuando abras Rambox, recuerda elegir la opción {enterpriseLogin} e introducir el siguiente ID de empresa:',
			enterpriseLogin: 'Inicio de sesión para empresas',
			copied: '¡Copiado!',
		},
		expired: {
			title: 'El enlace ha caducado',
			text: 'Este enlace ya ha caducado. Solicita uno nuevo.',
		},
		resend: {
			placeholder: 'Introduce tu correo electrónico',
			button: 'Reenviar el correo de verificación',
			sent: '¡Correo enviado! Revisa tu bandeja de entrada.',
		},
		error: {
			title: 'Enlace no válido',
		},
		validation: {
			passwordRequired: 'La contraseña es obligatoria.',
			passwordMin: 'La contraseña debe tener al menos 6 caracteres.',
			repeatPassword: 'Repite tu contraseña.',
			passwordsDoNotMatch: 'Las contraseñas no coinciden.',
			emailRequired: 'El correo electrónico es obligatorio.',
			emailInvalid: 'Introduce un correo electrónico válido.',
		},
		errors: {
			invalidLink: 'El enlace no es válido o está incompleto.',
			noAuthenticatedUser: 'No encontramos un usuario autenticado.',
			couldNotSetPassword: 'No pudimos guardar la contraseña. Inténtalo de nuevo.',
			emailMismatch: 'El correo electrónico no coincide con el de esta invitación.',
			signInFailed: 'No pudimos iniciar tu sesión. Inténtalo de nuevo.',
			couldNotReset: 'No pudimos restablecer la contraseña. Inténtalo de nuevo.',
			linkInvalidOrUsed: 'El enlace no es válido o ya ha sido utilizado.',
		},
	},

	website: {
		goBackToWebsite: 'Volver al sitio web',
		title: '¿Por qué deberías crear una cuenta?',
		benefits: {
			sync: 'Para sincronizar tu espacio de trabajo en todos tus equipos.',
			trial: 'Obtén 30 días de prueba del plan Pro con todas las funciones.',
			noCreditCard: 'No necesitas tarjeta de crédito ni ningún otro dato.',
			freePlan: 'Cuando termine la prueba, puedes seguir usando el plan Basic GRATIS.',
			easyRemoval: 'Eliminar tu cuenta es fácil si decides no seguir usando Rambox.',
		},
		downloadApp: '¿Ya tienes una cuenta? Descarga la aplicación',
		enterprise: '¿Tu empresa necesita Rambox Enterprise? Regístrate aquí',
	},

	// Códigos de error de Firebase. Los que no estén aquí muestran el mensaje
	// original devuelto por Firebase.
	firebase: {
		'auth/invalid-email': 'El correo electrónico no es válido.',
		'auth/user-disabled': 'Esta cuenta ha sido deshabilitada. Ponte en contacto con soporte.',
		'auth/user-not-found': 'No existe ninguna cuenta con este correo electrónico.',
		'auth/wrong-password': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/invalid-credential': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/invalid-login-credentials': 'El correo electrónico o la contraseña son incorrectos.',
		'auth/missing-password': 'Introduce tu contraseña.',
		'auth/email-already-in-use': 'Ya existe una cuenta con este correo electrónico.',
		'auth/weak-password': 'La contraseña es demasiado débil. Usa al menos 6 caracteres.',
		'auth/operation-not-allowed': 'Este método de inicio de sesión no está habilitado.',
		'auth/too-many-requests': 'Demasiados intentos. Espera unos minutos e inténtalo de nuevo.',
		'auth/network-request-failed': 'Error de conexión. Revisa tu conexión a internet e inténtalo de nuevo.',
		'auth/popup-closed-by-user': 'Se cerró la ventana de inicio de sesión antes de terminar.',
		'auth/cancelled-popup-request': 'Se canceló el inicio de sesión.',
		'auth/requires-recent-login': 'Inicia sesión de nuevo para completar esta acción.',
		'auth/expired-action-code': 'Este enlace ha caducado. Solicita uno nuevo.',
		'auth/invalid-action-code': 'Este enlace no es válido o ya ha sido utilizado.',
		'auth/account-exists-with-different-credential':
			'Ya existe una cuenta con este correo electrónico que usa otro método de inicio de sesión.',
		'auth/internal-error': 'Algo ha salido mal. Inténtalo de nuevo.',
	},
};
